import { motion } from "framer-motion";
import { IoMenu } from "react-icons/io5";
import { NavLink, NavLink as RouterLink } from "react-router-dom";
import styled from "styled-components";

import * as mixins from "@/styles/mixins";
import * as typography from "@/styles/typography";
import { colors } from "@/styles/variables";

const smallScreenSize = "900px";

export const Container = styled.div`
  border-bottom: 1px solid #e0e0e0;
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const FullWidthNav = styled.div`
  display: flex;
  width: 100%;
  height: inherit;
  align-items: center;

  @media screen and (max-width: ${smallScreenSize}) {
    display: none;
  }
`;

export const LogoWrapper = styled(RouterLink)`
  margin: 1rem 2rem 0.5rem;
  padding: 0 1rem;
`;

export const Links = styled.div`
  display: inline-flex;
`;

export const Link = styled(RouterLink)`
  font: 16px/22px "Museo Sans", sans-serif;
  color: #000;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  letter-spacing: 0.08em;
  white-space: pre;
  margin-right: 1.5rem;
  padding: 0.5rem;

  &:not(.active):hover {
    color: ${colors.darkBlue};
  }

  &.active {
    position: relative;
    cursor: default;

    &:after {
      content: "";
      position: absolute;
      height: 6px;
      background: ${colors.darkBlue};
      width: 100%;
      left: 0;
      top: 3rem;
    }
  }
`;

export const LogoutLink = styled(Link)`
  margin-left: 1rem;
  margin-right: 1rem;
`;
export const RightContainer = styled.div`
  margin-left: auto;
  margin-right: 1rem;
`;

export const ResponsiveNav = styled.div`
  @media screen and (min-width: ${smallScreenSize}) {
    display: none;
  }
`;

export const MenuIcon = styled(IoMenu)`
  margin-right: 0.5rem;
`;

export const MenuButton = styled.button`
  ${mixins.buttonReset()};

  margin: 0 1rem;
  font: 500 18px/22px ${typography.fontFamilyDefault}, sans-serif;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CloseMenuButton = styled.button`
  ${mixins.buttonReset()};

  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 11;
`;

export const ResponsiveMenu = styled(motion.div)`
  outline: 2px solid dodgerblue;
`;

export const MenuItems = styled(motion.ul)`
  list-style: none;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background: #fff;
  z-index: 10;
  padding: 6.5rem 2rem 2rem;
`;

export const MenuItem = styled(motion.li)`
  margin: 0 0 2.5rem;
`;

export const MenuLink = styled(NavLink)`
  font: 400 32px/40px ${typography.fontFamilySerif};
  text-decoration: none;
  color: #000;
`;

export const LogoutButtonWrapper = styled(motion.div)`
  margin-top: 4rem;
`;
export const ChangePasswordWrapper = styled(motion.div)`
  margin-top: 4rem;
`;

export const LogoutNavLink = styled(Link)`
  ${mixins.buttonReset()};
  ${mixins.buttonAppearance()};

  border-color: #000;
  background: #fff;
  color: #000;
`;

export const SubContainer = styled.div`
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const SubLink = styled(RouterLink)`
  color: #000;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  letter-spacing: 0.08em;
  white-space: pre;
  margin-right: 1.5rem;
  padding: 0.5rem;

  &:not(.active):hover {
    color: ${colors.darkBlue};
  }

  &.active {
    position: relative;
    cursor: default;

    &:after {
      content: "";
      position: absolute;
      height: 6px;
      background: ${colors.darkBlue};
      width: 100%;
      left: 0;
      top: 3rem;
    }
  }
`;
